<template>
  <div class="lane-items">
    <table :class="['items-list', type]">
      <thead>
        <tr>
          <!-- <th>Key</th> -->
          <th>Name</th>
          <th>Cost</th>
          <th>Score</th>
          <th v-if="type === 'product'">Decklist</th>
          <th>Tier</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item of items" class="row item" :key="item.key">
          <!-- <td><code class="key" v-text="item.key" /></td> -->
          <td>
            <div class="label" v-text="item.label" />
            <div class="description" v-text="item.description.substr(0, 30)" />
          </td>
          <td><span class="cost" v-text="item.cost" /></td>
          <td><span class="score" v-text="item.score" /></td>
          <td v-if="type === 'product'"><span class="list-required" v-text="item.requiresList ? 'Yes' : 'No'" /></td>
          <td><span class="tier" v-text="item.tier" /></td>
          <td>
            <span class="actions">
              <i class="action icon fas fa-pencil" @click="editItem(item)" />
              <i class="action icon fas fa-trash" @click="deleteItem(item)" />
            </span>
          </td>
        </tr>
      </tbody>
    </table>

    <button @click="editItem()">New {{ type }}</button>

    <template v-if="selectedItem">
      <hr />
      <LaneItemEditor
        v-model="selectedItem"
        :template="template"
        :type="type"
        @saveItem="saveItem" />
    </template>
  </div>
</template>

<script>
import shortid from 'shortid'
import LaneItemEditor from '@/components/LaneItemEditor'

export default {
  name: 'LaneItems',
  props: ['items', 'type', 'template'],
  components: { LaneItemEditor },
  data () {
    return {
      selectedItem: null
    }
  },
  methods: {
    editItem (item) {
      if (!item) {
        item = {
          tier: 0,
          requiresList: false,
          rules: []
        }
      }
      this.selectedItem = item
    },

    deleteItem (item) {
      if (!confirm(`Are you sure you want to delete ${this.type} "${item.label}"?`)) {
        return
      }
      const idx = this.items.indexOf(item)
      if (idx !== -1) {
        this.items.splice(idx, 1)
      }
    },

    saveItem (item) {
      const updatedItem = {
        ...item
      }
      Object.assign(this.selectedItem, item)
      if (!updatedItem.key) {
        updatedItem.key = shortid.generate()
        this.items.push(updatedItem)
      }
      this.selectedItem = null
    }
  },
  watch: {
    items () {
      this.selectedItem = null
    }
  }
}
</script>

<style scoped>
table.items-list {
  border-spacing: 0.5em;
  width: 100%;
}
table.items-list thead {
  font-size: 0.75em;
  color: #666;
}
table.items-list thead th {
  padding: 0.5em;
  border-bottom: 1px solid #ccc;
}
table.items-list .actions {
  font-size: 0.75em;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
table.items-list .action {
  cursor: pointer;
  padding: 0.5em;
}
table.items-list .description {
  font-size: 0.7em;
  display: block;
}
</style>
